import { IAuthenticationUseCase, UserRepository, SubscriptionUseCase } from '../usecases';
import { AnalyticsRepository, AccountContext } from '../repository/analytics.repository';

/**
 * Identity Service
 * Manages user authentication, profiles, roles, and permissions
 * Handles user registration, login, profile management, and role-based access
 */
export class IdentityService {
  constructor(
    private authUseCase: IAuthenticationUseCase,
    private subscriptionUseCase: SubscriptionUseCase,
    private userRepo: UserRepository,
    private analyticsRepo: AnalyticsRepository
  ) {}

  /**
   * Complete user registration and onboarding
   */
  async registerUser(
    userData: {
      email: string;
      username: string;
      password: string;
      confirmPassword: string;
      acceptTerms: boolean;
      marketingConsent?: boolean;
    },
    context?: AccountContext
  ): Promise<{
    user: any;
    session: any;
    onboardingSteps: any[];
    featureFlags: Record<string, boolean>;
    welcomeContent: any[];
  }> {
    console.log('[IdentityService.registerUser] START - Email:', userData.email, 'Username:', userData.username, 'Context:', context);
    try {
      // Register user
      console.log('[IdentityService.registerUser] Calling authUseCase.registerUser');
      const registrationResult = await this.authUseCase.registerUser({
        email: userData.email,
        username: userData.username,
        password: userData.password,
        confirmPassword: userData.password,
        acceptTerms: userData.acceptTerms,
        marketingConsent: userData.marketingConsent,
        context
      });
      console.log('[IdentityService.registerUser] Auth registration completed for user:', registrationResult.user.id);

      const userProfile = registrationResult.user;
      console.log('[IdentityService.registerUser] Using registered user profile:', userProfile.id);

      // Generate onboarding steps
      console.log('[IdentityService.registerUser] Generating onboarding steps');
      const onboardingSteps = [
        { id: 'profileSetup', title: 'Complete Your Profile', completed: false },
        { id: 'subscriptionSetup', title: 'Choose Your Plan', completed: false },
        { id: 'firstCourse', title: 'Enroll in Your First Course', completed: false }
      ];

      // Generate feature flags based on subscription
      console.log('[IdentityService.registerUser] Generating feature flags for FREE tier');
      const featureFlags = {
        canCreateCourses: false,
        canAccessPremiumContent: false,
        canBookProfessionals: false,
        canSellContent: false,
        advancedAnalytics: false
      };

      // Generate welcome content
      console.log('[IdentityService.registerUser] Generating welcome content');
      const welcomeContent = [
        {
          type: 'announcement',
          title: 'Welcome to DanceRealmX!',
          content: 'Your journey to mastering dance begins here.',
          priority: 'high'
        }
      ];

      console.log('[IdentityService.registerUser] SUCCESS - Registration completed for user:', userProfile.id, 'with', onboardingSteps.length, 'onboarding steps');
      return {
        user: userProfile,
        session: registrationResult.session,
        onboardingSteps,
        featureFlags,
        welcomeContent
      };
    } catch (error) {
      console.error('[IdentityService.registerUser] ERROR:', error);
      throw error;
    }
  }
}
